var alerts = document.querySelectorAll('.ga-alert');
window._gaq = window._gaq || [];
var tagId = window._ppGaTrackingId || 'G-HF7ERE6B6Z';
window._gaq.push(['_setAccount', tagId]);
window._gaq.push(['_trackPageview']);
window._usingGTag = false;

(function () {
	if (tagId.charAt(0) === 'G') {
		window._usingGTag = true;
		var gtagScript = document.createElement('script');
		gtagScript.type = 'text/javascript';
		gtagScript.async = true;
		switch (tagId) {
			case 'G-HF7ERE6B6Z': {
				gtagScript.src = '/dist/JavaScript/3rdParty/GoogleAnalytics/gtag_G-HF7ERE6B6Z.js';
				gtagScript.integrity = 'sha384-rMetArECVsuuAXwd213Hyf3O3y/2VKYPx+HqGDvHwDoLRzEXQ9CIkDoFPiveV5mD';
				gtagScript.crossOrigin = 'anonymous';
				break;
			}
			case 'G-NJGDS0M4GC': {
				gtagScript.src = '/dist/JavaScript/3rdParty/GoogleAnalytics/gtag_G-NJGDS0M4GC.js';
				gtagScript.integrity = 'sha384-VffyuO1QjZ4C4nOrSHB9kb8vYy7269CaHcKubuzdbpasSV+etN4uzMlDIyFuIkdq';
				gtagScript.crossOrigin = 'anonymous';
				break;
			}
			case 'G-45TQBLV16J': {
				gtagScript.src = '/dist/JavaScript/3rdParty/GoogleAnalytics/gtag_G-45TQBLV16J.js';
				gtagScript.integrity = 'sha384-S28yxsn8pvO/UkY7WJaQrv/wqnvR0URRl0/SpZg0IesDHLCzd1i7F7gs5sJLDMEZ';
				gtagScript.crossOrigin = 'anonymous';
				break;
			}
			default:  {
				gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;
			}
		}
		var gdoc = document.getElementsByTagName('script')[0];
		gdoc.parentNode.insertBefore(gtagScript, gdoc);

		window.dataLayer = window.dataLayer || [];
		window._gtag = window._gtag = function () {
			window.dataLayer.push(arguments);
		};

		window._gtag('js', new Date());
		window._gtag('config', tagId);
		window._gtag('event', 'page_view');
	} else {
		var ga = document.createElement('script');
		ga.type = 'text/javascript';
		ga.async = true;
		ga.src = '/dist/JavaScript/3rdParty/GoogleAnalytics/analytics.js';
		ga.integrity = 'sha384-+SBzFbaeO0hVei6nQW7V0UKCxWrf5rVCGodk0XvtzAhV0kS1Bp3U8IRYgQbm+J5X';
		ga.crossOrigin = 'anonymous';
		var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);
	}
})();

var ppTracking = (function () {
	var init = function () {

		// Track pixel density ratio
		var pixelRatio = window.devicePixelRatio ? String(window.devicePixelRatio) : "1";
		if (window._usingGTag) {
			window._gtag('event', 'pixel_ratio', { ratio: pixelRatio });
		} else {
			window._gaq.push(['_setCustomVar', 1, 'Pixel Ratio', pixelRatio, 1]);
		}
	};

	return { init: init };
}());

document.addEventListener('DOMContentLoaded', function (event) {
	ppTracking.init();
});

if (alerts) {
	Array.prototype.forEach.call(alerts, function (el, i) {
		el.addEventListener('click', function (event) {
			if (window._usingGTag) {
				window._gtag('event', 'ga_alert', { title: document.title, text: el.innerText });
			} else {
				window._gaq.push(['_trackEvent', document.title, el.innerText]);
			}
		});
	});
}
